module.exports = __webpack_public_path__ + "img/dalou_4_3@2x.903c1857.png";